import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
`;

export const FormWrapper = styled.div`
  background: ${({ theme }: any) => theme.palette[10]};
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const FormRow = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 24px;
  
  @media (max-width: 968px) {
    flex-direction: column;
  }
`;

export const FormColumn = styled.div<{ flex?: number }>`
  flex: ${({ flex }) => flex || 1};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HelpColumn = styled.div`
  flex: 0 0 350px;
  background: ${({ theme }: any) => theme.palette[20]};
  border-radius: 8px;
  padding: 20px;
  
  @media (max-width: 968px) {
    flex: 1;
  }
`;

export const HelpSection = styled.div`
  margin-bottom: 20px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FileInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FileInput = styled.input`
  display: none;
`;

export const FileLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: ${({ theme }: any) => theme.palette[30]};
  border: 1px solid ${({ theme }: any) => theme.palette[100]};
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: ${({ theme }: any) => theme.palette[40]};
  }
`;

export const FileNameDisplay = styled.div`
  flex: 1;
  padding: 10px;
  background: ${({ theme }: any) => theme.palette[20]};
  border: 1px solid ${({ theme }: any) => theme.palette[100]};
  border-radius: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileActions = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  label {
    padding: 8px;
    border-radius: 4px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
      background: ${({ theme }: any) => theme.palette[50]};
    }
  }
`;

export const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

export const Chip = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  background: ${({ theme }: any) => theme.palette[100]};
  border-radius: 16px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background: ${({ theme }: any) => theme.palette[200]};
  }
`;

export const ColorPickerWrapper = styled.div`
  display: flex;
  gap: 16px;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid ${({ theme }: any) => theme.palette[100]};
`;

export const ColorPickerSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }: any) => theme.palette[20]};
  border: 1px solid ${({ theme }: any) => theme.palette[100]};
`;

export const ColorPickerHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ColorInputsRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

export const ColorFieldGroup = styled.div`
  flex: 1;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ColorLabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ColorValue = styled.span`
  font-size: 13px;
  color: ${({ theme }: any) => theme.grey[700]};
`;

export const NativeColorInput = styled.input.attrs({ type: 'color' })`
  width: 100%;
  height: 44px;
  border-radius: 6px;
  border: 1px solid ${({ theme }: any) => theme.grey[350]};
  background: ${({ theme }: any) => theme.palette[10]};
  cursor: pointer;
  padding: 0;

  &::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  &::-webkit-color-swatch,
  &::-moz-color-swatch {
    border-radius: 6px;
    border: none;
  }
`;

export const Swatches = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SwatchButton = styled.button<{ color: string; isActive: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: ${({ isActive, theme }: any) =>
    isActive ? `2px solid ${theme.primary[400]}` : `1px solid ${theme.palette[100]}`};
  background: ${({ color }) => color};
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border 0.18s ease;
  padding: 0;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }: any) => theme.primary[400]};
    outline-offset: 2px;
  }
`;

export const PreviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ScheduleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TimePickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TimePickerWrapper = styled.div`
  width: 100%;
  max-width: 220px;

  [data-slot='label'] {
    display: none;
  }

  [data-slot='input-wrapper'] {
    height: 40px;
    border-radius: 4px;
    border: ${({ theme }: any) => `1px solid ${theme.grey[350]}`};
    background: ${({ theme }: any) => theme.palette[10]};
    padding: 0 12px;
    transition: border 0.18s ease, box-shadow 0.18s ease;
  }

  [data-slot='input-wrapper'][data-focus='true'] {
    border: ${({ theme }: any) =>
      theme.isDark ? `1px solid #4671F6` : `1px solid ${theme.primary[300]}`};
    box-shadow: ${({ theme }: any) =>
      theme.isDark
        ? '0px 0px 0px 3px rgba(70, 113, 246, 0.5)'
        : `0px 0px 0px 3px #E0EAFF`};
  }

  [data-slot='input-wrapper'][data-hover='true'] {
    border: ${({ theme }: any) =>
      theme.isDark ? `1px solid #4671F6` : `1px solid ${theme.primary[300]}`};
    box-shadow: ${({ theme }: any) =>
      theme.isDark
        ? '0px 0px 0px 3px rgba(70, 113, 246, 0.5)'
        : `0px 0px 0px 3px #E0EAFF`};
  }

  [data-slot='segment'] {
    color: ${({ theme }: any) => theme.palette[900]};
    font-size: 15px;
    line-height: 20px;
  }

  [data-slot='helper-wrapper'] {
    display: none;
  }
`;

export const ScheduleHelper = styled.span`
  font-size: 12px;
  color: ${({ theme }: any) => theme.grey[700]};
`;
